export default __webpack_public_path__ + "static/media/7UT513.a6376920.png";